import React, { Component } from 'react';

// -----------------------------------------------------------------------

// Product collection

class ProductCollection extends Component
{
    constructor (props)
    {
        // Props
        super(props);

        // State
        this.state = {
            opened: true
        }

        this.function_toggle = this.function_toggle.bind(this);
    }

    function_toggle()
    {
        this.setState({
            opened: !this.state.opened
        });
    }

    render()
    {
        if (this.props.content_product_types.length > 0)
        {
            const product_types = [];
            for (let i = 0; i < this.props.content_product_types.length; i++)
            {
                if (this.props.content_product_types[i]['collection_id'] === this.props.product_collection_id)
                {
                    product_types.push(
                        <React.Fragment key={i}>
                            <ProductType
                                content_product_type={this.props.content_product_types[i]}
                                index={i}
                                selection={this.props.selection_product_types[i]}
                                translation_language_key={this.props.translation_language_key}
                                function_selection_product_type={this.props.function_selection_product_type}
                                function_translate={this.props.function_translate} />
                        </React.Fragment>
                    );
                }
            }
            
            let class_toggle = 'product-collection-header-toggle-closed';
            if (this.state.opened === true)
                class_toggle = 'product-collection-header-toggle-opened';

            let class_product_collection = 'product-table-checkmark-disabled';
            let { total, total_selected } = this.props.function_get_selection_product_collection(this.props.product_collection_id);
            if (total === total_selected)
                class_product_collection = 'product-table-checkmark-enabled';

            return (
                <React.Fragment>
                    <div className="product-collection-header-container" onClick={() => this.function_toggle()}>
                        <div className="product-collection-header-title">{this.props.title}</div>
                        <div className={class_toggle}></div> 
                    </div>
                    
                    { this.state.opened === true &&
                        <React.Fragment>
                            <div className="product-table-header-container">
                                <div className="product-table-header-left">
                                    <div className={class_product_collection} onClick={() => this.props.function_selection_product_collection(this.props.product_collection_id)}></div>
                                    <div className="product-table-title-product">{this.props.function_translate('product_table_product')}</div>
                                </div>
                                <div className="product-table-header-right">
                                    <div className="product-table-title-parking">{this.props.function_translate('product_table_parking')}</div>
                                    <div className="product-table-title-openings">{this.props.function_translate('product_table_openings')}</div>
                                    <div className="product-table-title-fillingandwidth">{this.props.function_translate('product_table_filling_and_width')}</div>
                                    <div className="product-table-title-more"></div>
                                </div>
                            </div>
                            <div className="product-table-rows-container">
                                {product_types}
                            </div>
                        </React.Fragment>
                    }
                </React.Fragment>
            );
        }
        else
        {
            return (
                <React.Fragment></React.Fragment>
            );
        };
    }   
}

// -----------------------------------------------------------------------

// Product type

class ProductType extends Component
{
    render()
    {
        let class_product_collection = 'product-table-checkmark-disabled';
        if (this.props.selection === true)
            class_product_collection = 'product-table-checkmark-enabled';

        return (
            <div className="product-table-row-container">
                <div className="product-table-row-left">
                    <div className="product-table-row-checkmark">
                        <div className={class_product_collection} onClick={() => this.props.function_selection_product_type(this.props.index)}></div>
                    </div>
                    <div className="product-table-row-preview"></div>
                    <div className="product-table-row-preview-2"></div>
                    <div className="product-table-row-product">
                        <div className="product-table-product-title">
                            {this.props.content_product_type['displayname_'+this.props.translation_language_key]}
                        </div>
                        <div className="product-table-product-text">
                            {this.props.content_product_type['property_dimensions']}
                            <div className="product-table-product-text-split"></div> 
                            {this.props.content_product_type['property_application__displayname_'+this.props.translation_language_key]}
                            <div className="product-table-product-text-split"></div>
                            {this.props.content_product_type['property_weightclass__displayname_'+this.props.translation_language_key]}
                        </div>
                    </div>
                </div>
                <div className="product-table-row-right">
                    
                    { /*
                    {this.props.content_product_type['property_filling_grass']}
                    {this.props.content_product_type['property_filling_gravel_min']}
                    {this.props.content_product_type['property_filling_gravel_max']}
                    {this.props.content_product_type['property_jointwidth']}
                    {this.props.content_product_type['property_jointdiameter']}
                    {this.props.content_product_type['property_waterpermeability']}
                    */ }
                    
                    { this.props.content_product_type['property_parking'] === true &&
                        <div className="product-table-row-parking">P</div>
                    }
                    
                    <div className="product-table-row-openings">
                        { this.props.content_product_type['property_wateropening'] !== null &&
                            <React.Fragment>
                                {this.props.content_product_type['property_wateropening']}%
                            </React.Fragment>
                        }
                        { this.props.content_product_type['property_grassopening'] !== null &&
                            <React.Fragment>
                                { this.props.content_product_type['property_wateropening'] !== null &&
                                    <div className="product-table-product-text-split"></div>
                                }
                        
                                {this.props.content_product_type['property_grassopening']}%
                            </React.Fragment>
                        }
                    </div>
                    
                    <div className="product-table-row-fillingandwidth">
                        {this.props.content_product_type['property_filling_grass']} kg/m²
                        
                        { this.props.content_product_type['property_filling_grass'] !== null &&
                            <div className="product-table-product-text-split"></div>
                        }

                        { (this.props.content_product_type['property_filling_gravel_min'] !== null || this.props.content_product_type['property_filling_gravel_max'] !== null) &&
                            <React.Fragment>
                                {this.props.content_product_type['property_filling_gravel_min']}-{this.props.content_product_type['property_filling_gravel_max']} kg/m²
                            </React.Fragment>
                        }
                        
                        { (this.props.content_product_type['property_filling_gravel_min'] !== null || this.props.content_product_type['property_filling_gravel_max'] !== null) &&
                            <div className="product-table-product-text-split"></div>
                        }

                        { this.props.content_product_type['property_jointwidth'] !== null &&
                            <React.Fragment>
                                {this.props.content_product_type['property_jointwidth']} mm
                            </React.Fragment>
                        }

                        { this.props.content_product_type['property_jointdiameter'] !== null &&
                            <React.Fragment>
                                Ø{this.props.content_product_type['property_jointdiameter']} mm
                            </React.Fragment>
                        }

                        { (this.props.content_product_type['property_jointwidth'] === null && this.props.content_product_type['property_jointdiameter'] === null) &&
                            <React.Fragment>
                                {this.props.function_translate('product_table_variable')}
                            </React.Fragment>
                        }
                    </div>
                    <div className="product-table-more"></div>
                </div>
            </div>
        )
    }
}

// -----------------------------------------------------------------------

// Product

class Product extends Component
{
    render()
    {
        if (this.props.content_product_collections.length > 0)
        {
            const product_collections = [];
            for (let i = 0; i < this.props.content_product_collections.length; i++)
            {
                product_collections.push(
                    <React.Fragment key={i}>
                        <ProductCollection
                            content_product_types={this.props.content_product_types}
                            product_collection_id={this.props.content_product_collections[i]['id']}
                            selection_product_types={this.props.selection_product_types}
                            title={this.props.content_product_collections[i]['displayname_'+this.props.translation_language_key]}
                            translation_language_key={this.props.translation_language_key}
                            function_get_selection_product_collection={this.props.function_get_selection_product_collection}
                            function_selection_product_collection={this.props.function_selection_product_collection}
                            function_selection_product_type={this.props.function_selection_product_type}
                            function_translate={this.props.function_translate} />
                    </React.Fragment>
                );
            }
            
            return(
                <React.Fragment>
                    <div className="product-page">
                        <h2 className="product-info-title">{this.props.function_translate('product_info_title')}</h2>
                        <p className="product-info-text">{this.props.function_translate('product_info_text')}</p>
                        
                        {product_collections}
                    </div>
                </React.Fragment>
            );
        }
        else
        {
            return (
                <React.Fragment></React.Fragment>
            );
        }
    }
}

export default Product